export default __webpack_public_path__ + "1366cb106650098b0410306cea415d44.svg";